import React, { useState, useEffect, useRef } from 'react';
import ClientTable from './ClientTable';
import { getClients, clearClients } from '../../flux/actions/clientActions';
import { Container, Row, Col, Button, Input } from 'reactstrap';

import { connect } from 'react-redux';
import { ClientContainer, IClientReduxProps, ITarget } from '../../types/interfaces';
import ClientAdd from './ClientAdd';
import LoadingPage from '../../pages/loading';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faSearch } from '@fortawesome/free-solid-svg-icons'
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';
import Loading from '../Loading';

const ClientContainerComponent = ({
  getClients,
  clearClients,
  client,
  auth
 }: ClientContainer) => {

  const { clients, loading } = client;
  const [tableData, setTableData] = useState(clients);
  const [modal, setModal] = useState(false);
  const selectOptions = [{value: constants.CLIENTS_SELECT_QUICK_SEARCH, label: "Recherche rapide"}, {value: constants.CLIENTS_SELECT_CIN, label: "CIN"}, {value: constants.CLIENTS_SELECT_PASSPORT, label: "Passeport"}, {value: constants.CLIENTS_SELECT_LAST_NAME, label: "Nom de famille"}];
  const [selectedValue, setSelectedValue] = useState(selectOptions[0]);
  const [searchValue, setSearch] = useState('');
  const searchRef = useRef<HTMLInputElement>(document.createElement("input"));
  
  const handleToggle = () => setModal(!modal);

  const handleSelectChange = data => {
    setSelectedValue(data || '');
    searchRef.current.focus();
  }

  const searchChangeHandler = (e: ITarget) => setSearch(e.target.value);
  const onSearchFocus = (e) => {
    e.target.select();
  };

  const handleSearchKeyDown = (event) => {
    if(event.key === 'Enter')
      search()
  }

  const search = () => {
    if(auth?.user?.privileges)
      getClients(auth.user.privileges.includes(PRIVILEGE.LIST_CLIENTS), selectedValue.value, searchValue);
  }

  useEffect(() => {
    search();
  }, [getClients, auth?.user]);

  useEffect(() => {
    return () => {
      clearClients();
    }
  }, []);

  useEffect(() => {
    console.log("clients", clients);
    setTableData(clients);
  }, [clients]);

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="8"><h2 className="title"><FontAwesomeIcon icon={faUsers} />&nbsp;&nbsp;Liste des Clients</h2></Col>
          {auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="4" className="modalAddBtnCol">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setModal(true)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un client</Button>
          </Col>}
        </Row>
        {auth?.user?.privileges && !auth.user.privileges.includes(PRIVILEGE.LIST_CLIENTS) ? <Row className="justify-content-center mt-2 mb-1 fadeAnimation">
          <Col xs="12" md="3" className="mb-2 mb-md-0">
              <Select
                name="searchSelect"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={selectOptions[0]}
                value={selectedValue}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleSelectChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={false}
                options={selectOptions}                
              />
          </Col>
          <Col xs="12" md="3" style={{display: "flex"}}>
            <Input style={{display: "inline-flex", flex: 1, marginRight: "10px"}} placeholder="N°..." innerRef={searchRef} value={searchValue} onChange={searchChangeHandler} onKeyDown={handleSearchKeyDown} onFocus={onSearchFocus} />
            <Button className="btnA"
              onClick={search}>
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col>
        </Row> : null}
      </Container>
      {loading ? <Loading /> : <ClientTable clientsData={tableData} setTableData={setTableData} />}
      <ClientAdd modal={modal} setModal={setModal} handleToggle={handleToggle} />
    </>
  );
};

const mapStateToProps = (state: IClientReduxProps) => ({
  client: state.client,
  auth: state.auth
});

export default connect(mapStateToProps, { getClients, clearClients })(ClientContainerComponent);
